import {TachoMonitoring} from "@/components/monitoring/tacho";

export default {
    namespaced: true,

    state: {
        src: '//dapi.kakao.com/v2/maps/sdk.js?autoload=false&appkey=7aec014ddd4271cfb72a17cee5489af9&libraries=services,clusterer,drawing',
        container: document.getElementById("map"),
        defaultLevel: 5,
        defaultCenter: {lat: 35.867, lng: 128.59},
        nowLevel: 3,
        nowLocation: {lat: 35.867, lng: 128.59},
        markerSize: 35,
        markers: {},
        overlays: {},
        currentMaker: Object,
        polyLines: {},
        infoWindow: Object,
        searchForms : {},
        markerArrow  : []
    },
    getters: {
        getNowLevel(state) {
            return state.nowLevel
        }
    },
    mutations: {
        setLevel(state) {
            state.nowLevel = window.kakaoMap.getLevel()
        },
        setLocation(state) {
            state.nowLocation = {lat: window.kakaoMap.getCenter().getLat(), lng: window.kakaoMap.getCenter().getLng()}
        },
        setInfoWindow(state) {
            state.infoWindow = new kakao.maps.InfoWindow({content:
                    `
                    <div style="width: 50px; height: 50px"><div>
                `
            });
        },
        closeInfoWindow(state) {
            state.infoWindow.close();
        }
    },
    actions: {
        moveCenter({state}, value) {
            if (value !== null && value !== undefined
                && !isNaN(value.lat) && !isNaN(value.lng)
                && value.lat !== '' && value.lng !== '') {
                window.kakaoMap.setCenter(new kakao.maps.LatLng(value.lat, value.lng));
            }
        },
    },
    modules: {}
}